import IApplicationState from 'app/types/state';
// import { IOrganisationsState, IOrganisationsSelector } from 'app/ducks/organisations/types';

import _ from 'lodash';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.organisations.organisationsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getOrganisationsByIdInSelectFormat(state: IApplicationState): any {
  return _.map(state.organisations.organisationIds, (n) => mapSelect(state, n));
}

export function getOrganisationById(state: IApplicationState, id): any {
  if (
    state.organisations.organisationsById !== undefined
           && id != null
  ) {
    return state.organisations.organisationsById[id];
  }
  return {};
}

export function getOrganisationConnectionCode(state: IApplicationState, connectionCode: string): any {
  if (
    connectionCode !== null && state.organisations.organisationsById !== undefined
  ) {
    return _.find(state.organisations.organisationsById, {
      uniqueConnectionCode: connectionCode,
    });
  }
  return {};
}

export function getGroupsFilteredByTagInSelectFormat(
  state: IApplicationState,
  tagId,
): any {
  const { groupsById }: IGroupsState = state.groups;
  const groups = _.filter(groupsById, { tags: [tagId] });
  const mappedTeams = _.map(groups, (n) => mapSelect(state, n.id));
  return mappedTeams;
}
export function getCurrentOrganisation(state: IApplicationState): any {
  const {
    organisationsById,
    currentOrganisationId,
  } = state.organisations;
  if (
    organisationsById !== undefined
           && currentOrganisationId !== undefined
  ) {
    return organisationsById[state.organisations.currentOrganisationId];
  }
  return {};
}

export function getOrganisations(state: IApplicationState): any {
  return {
    ...state.organisations,
    organisationsByIdInSelectFormat: getOrganisationsByIdInSelectFormat(
      state,
    ),
    currentOrganisation: {
      ...getCurrentOrganisation(state),
    },
  };
}
